import React from 'react';
import LoadIndicator from 'devextreme-react/load-indicator';
import './_scopedWaitOverlay.scss';

interface ScopedWaitOverlayProps {
    visible: boolean;
    label?: string;
    logoSrc?: string;
    mode?: 'Broker' | 'Admin' | 'Apply';
}

// This component is used for friendly wait indicators that can be scoped to a paneled area in the apps
// as opposed to WaitOverlay that is designed to mask the entire web application
export const ScopedWaitOverlay: React.FC<ScopedWaitOverlayProps> = ({ visible, label, logoSrc, mode }) => {
    if (!visible) return null;

    // Only resolve a logo if:
    // 1. logoSrc is NOT provided
    // 2. mode IS provided
    let resolvedLogoSrc = logoSrc;

    // Only resolve logo if:
    // 1. logoSrc is NOT provided
    // 2. mode IS provided
    if (!resolvedLogoSrc && mode) {
        //Use some default paths based on context of which it was called
        switch (mode) {
            case 'Broker':
                resolvedLogoSrc = '/images/broker/logo.webp.html';
                break;
            case 'Admin':
                resolvedLogoSrc = '/images/broker/logo.webp.html';
                break;
            case 'Apply':
                resolvedLogoSrc = '/assets/img/logo.webp.html';
                break;
            default:
                resolvedLogoSrc = undefined;
        }
    }

    return (
        <div className='scoped-wait-overlay'>
            <div className='scoped-wait-overlay__content'>
                <LoadIndicator
                    visible
                    height={32}
                    width={32}
                />

                {resolvedLogoSrc && (
                    <div className='scoped-wait-overlay__brand'>
                        <img
                            className='scoped-wait-overlay__logo'
                            src={resolvedLogoSrc}
                            alt={label}
                        />
                        <p className='scoped-wait-overlay__text'>{label}</p>
                    </div>
                )}

                {!resolvedLogoSrc && <p className='scoped-wait-overlay__text'>{label}</p>}
            </div>
        </div>
    );
};
